import React, { useContext, useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Context, PageConsumer } from '../context/theme' 
import { useLocation } from 'react-router-dom'
import { getCurrentPage } from '../utils/api'
import { Helmet } from "react-helmet";


export default function Header({ frontpageObject, small, smallTitle, leftImage = false, type = '', showTitle = true }){
  const history = useLocation() 
  const [historyChange, setHistoryChange] = useState(history)
  const [currentPageObject, setCurrentPageObject] = useContext(Context)
 
  useEffect(() => { 
    if (currentPageObject){
      getCurrentPage().then(( currentPageObject ) => {
        setCurrentPageObject( currentPageObject) 
        setHistoryChange(history)
      })  
    }
  }, [history]);
  
 
  if(small){
    return ( 
        
      <PageConsumer>
          {([currentPageObject]) =>
          currentPageObject && <> 
              <div className={`main-section__logo ${type}`}>
                <NavLink  to='/' className={`nav-link`}>
                  <img src={frontpageObject.acf.logo} alt="logo" />
                </NavLink>
                {leftImage && <img src={leftImage} alt="main_img" className="left-image" />}
              </div>
       
              {
                showTitle && (
                  smallTitle
                  ? <div className='main-section__titleSmall'
                    dangerouslySetInnerHTML={{__html: frontpageObject.title.rendered}}
                  />
                  : <div className='main-section__title'
                    dangerouslySetInnerHTML={{__html: currentPageObject.acf.feedback.title}}
                  />
                )
                
              }
              {
                currentPageObject &&
                <Helmet>
                  <title>{`${currentPageObject.yoast_head_json.title}`}</title>
                  <meta name="description" content={`${currentPageObject.yoast_head_json.description}`} />
                  <meta name="robots" content={
                    Object.keys(currentPageObject.yoast_head_json.robots).forEach(function(key, index) {
                      currentPageObject.yoast_head_json.robots[key];
                    }) 
                  } />
                  <link rel="canonical" href={`${currentPageObject.yoast_head_json.canonical}`} />
                  <meta property="og:locale" content={`${currentPageObject.yoast_head_json.og_locale}`} />
                  <meta property="og:type" content={`${currentPageObject.yoast_head_json.og_type}`} />
                  <meta property="og:title" content={`${currentPageObject.yoast_head_json.og_title}`} />
                  <meta property="og:url" content={`${currentPageObject.yoast_head_json.og_url}`} />
                  <meta property="og:site_name" content={`${currentPageObject.yoast_head_json.article_modified_time}`} />
                  <meta property="article:modified_time" content="2022-11-14T15:26:19+00:00" />
                  <meta name="twitter:card" content={`${currentPageObject.yoast_head_json.twitter_card}`} />
     
                </Helmet>
              }
            </>
          }
 
      </PageConsumer>
    )
  }else{
    return (
      <PageConsumer>
        {([currentPageObject]) =>
          <header className={`header header_inner"`}>
              {
                currentPageObject &&
                <Helmet>
                  <title>{`${currentPageObject.yoast_head_json.title}`}</title>
                  <meta name="description" content={`${currentPageObject.yoast_head_json.description}`} />
                  <meta name="robots" content={
                    Object.keys(currentPageObject.yoast_head_json.robots).forEach(function(key, index) {
                      currentPageObject.yoast_head_json.robots[key];
                    }) 
                  } />
                  <link rel="canonical" href={`${currentPageObject.yoast_head_json.canonical}`} />
                  <meta property="og:locale" content={`${currentPageObject.yoast_head_json.og_locale}`} />
                  <meta property="og:type" content={`${currentPageObject.yoast_head_json.og_type}`} />
                  <meta property="og:title" content={`${currentPageObject.yoast_head_json.og_title}`} />
                  <meta property="og:url" content={`${currentPageObject.yoast_head_json.og_url}`} />
                  <meta property="og:site_name" content={`${currentPageObject.yoast_head_json.article_modified_time}`} />
                  <meta property="article:modified_time" content="2022-11-14T15:26:19+00:00" />
                  <meta name="twitter:card" content={`${currentPageObject.yoast_head_json.twitter_card}`} />
           
                </Helmet>
              }
            <div className="cont row header__cont">
              {
              currentPageObject &&
                <> 
 
              
                  <div className="header__logo">
                    <NavLink to='/?start=true' className={`nav-link`} >
                      <img src={frontpageObject.acf.logo} alt="logo" />
                    </NavLink>
                  </div>

                  <h1 className="header__title"
                    dangerouslySetInnerHTML={{__html: frontpageObject.title.rendered}}
                  />
                </>
              }
            </div>
          </header>
        }
      </PageConsumer>
      
    )
  }


}